<template>
    <div>
        <div class="menu-title">
            模型预设
        </div>
        <div class="menu-content">
            <div>
                <el-form  :inline="true" :model="qo" size="small" class="demo-form-inline">
                  <el-form-item label="名称：">
                    <el-input v-model="qo.LIKES_name" placeholder="请输入名称" style="width: 300px"></el-input>
                  </el-form-item>
                  <el-form-item >
                    <el-button type="success" icon="el-icon-search" @click="qo.pageNo=1;queryData()">搜 索</el-button>
                  </el-form-item>
                </el-form>
            </div>
            <div style="margin: 0px 0 20px 0">
                <el-button type="primary" icon="el-icon-plus" size="small" @click="createRow()">添加</el-button>
            </div>
            <div class="table-list">
                <el-table :data="result.records" style="width: 100%" >
                    <el-table-column type="index" label="序号" width="100" ></el-table-column>
                    <el-table-column prop="name" label="名称" ></el-table-column>
                    <el-table-column prop="name" label="是否默认" >
                      <template slot-scope="scope">
                        {{scope.row.isSelect?"是":"否"}}
                      </template>
                    </el-table-column>
                  <el-table-column prop="name" label="模型类型" >
                    <template slot-scope="scope">
                      {{scope.row.modelType=='local'?"本地":"在线"}}
                    </template>
                  </el-table-column>
                    <el-table-column prop="fileName" label="普通文件" ></el-table-column>
<!--                    <el-table-column prop="fileName1" label="破限文件" >-->
<!--                      <template slot-scope="scope">-->
<!--                        {{scope.row.modelType == 'online'?scope.row.fileName1:""}}-->
<!--                      </template>-->
<!--                    </el-table-column>-->
                    <el-table-column prop="name" label="状态" >
                      <template slot-scope="scope">
                        {{scope.row.status?"启用":"未启用"}}
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="160">
                        <template slot-scope="scope">
                            <el-button @click.native.prevent="statusRow(scope.row)"  type="text" size="small">
                              {{scope.row.status?"禁用":"启用"}}
                            </el-button>
                            <el-button @click.native.prevent="modifyRow(scope.row)"  type="text" size="small">
                                编辑
                            </el-button>
                            <el-button @click.native.prevent="removeRow(scope.row)"  type="text" size="small">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page-box">
                <el-pagination background
                               @current-change="handleCurrentChange"
                               :current-page="qo.pageNo"
                               :page-size="qo.pageSize"
                               :page-sizes="[10,20,30,40,50]" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next"
                               :total="result.total">
                </el-pagination>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false"
                :title="dialogName"
                :visible.sync="cmdDialogVisible"
                width="40%">
            <el-form ref="cmd" label-width="100px" :rules="rules" :model="cmd">
                <el-form-item label="名称" prop="name">
                    <el-input v-model="cmd.name" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="是否默认" prop="isSelect">
                  <el-radio-group v-model="cmd.isSelect">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              <el-form-item label="模型类型" prop="modelType">
                <el-radio-group v-model="cmd.modelType">
                  <el-radio label="local">本地</el-radio>
                  <el-radio label="online">在线</el-radio>
                </el-radio-group>
              </el-form-item>
                <el-form-item label="正文" prop="content">
                  <el-input v-model="cmd.content" placeholder="请输入正文" type="textarea"  :rows="5"></el-input>
                </el-form-item>
                <el-form-item label="普通文件" >
                  <el-upload
                      ref="upload"
                      :auto-upload="false"
                      action="#"
                      :on-change="handleFileChange"
                      :limit="2"
                      :show-file-list="false">
                    <el-button type="primary" icon="el-icon-upload2" size="small">上传文件</el-button>
                  </el-upload>
                  <div v-if="cmd.fileName">{{cmd.fileName}} <i class="el-icon-close close-icon-box" @click="clearFile('fileName','url')"></i></div>
                </el-form-item>
<!--                <el-form-item label="破限文件" v-if="cmd.modelType == 'online'">-->
<!--                  <el-upload-->
<!--                      ref="upload1"-->
<!--                      :auto-upload="false"-->
<!--                      action="#"-->
<!--                      :on-change="handleFileChange1"-->
<!--                      :limit="2"-->
<!--                      :show-file-list="false">-->
<!--                    <el-button type="primary" icon="el-icon-upload2" size="small">上传文件</el-button>-->
<!--                  </el-upload>-->
<!--                  <div v-if="cmd.fileName1">{{cmd.fileName1}}<i class="el-icon-close close-icon-box" @click="clearFile('fileName1','fileUrl')"></i></div>-->
<!--                </el-form-item>-->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cmdDialogVisible = false"  size="small">取 消</el-button>
                <el-button type="primary" @click="submitModify"  size="small">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import request, {getFileUrl} from '@/utils/request';

    var _this;
    export default {
        name: "unitManage",
        data() {
            return {
                qo: {
                    pageNo: 1,
                    pageSize: 10,
                    LIKES_name: '',
                    EQL_type:2,
                    DESCI_createTime:1,
                },
                result: {
                    records: [],
                    total: 0
                },
                dialogName: '编辑',
                cmdDialogVisible: false,
                cmd: {},
                rules: {
                    // label: [
                    //     {required: true, message: '请输入标签'},
                    // ],
                    // name: [
                    //   {required: true, message: '请输入文案名称'},
                    // ],
                    // content: [
                    //   {required: true, message: '请输入文案内容'},
                    // ],
                },
                path:getFileUrl()
            }
        },
        mounted() {
            _this = this;
            _this.queryData();
        },
        methods: {
            queryData() {
                request({
                    url: '/public/presets/query_pages',
                    method: 'post',
                    data: _this.qo
                }).then(res => {
                    _this.result.records = res.records;
                    _this.result.total = res.total;
                });
            },
            handleCurrentChange(val) {
                _this.qo.pageNo = val;
                _this.queryData();
            },
            handleSizeChange(val) {
                _this.qo.pageNo = 1;
                _this.qo.pageSize = val;
                _this.queryData();
            },
            removeRow(item) {
                _this.$confirm('此操作将永久删除记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    request({
                        url: '/public/presets/remove/' + item.id,
                        method: 'post'
                    }).then(res => {
                        _this.$message.success("删除成功");
                        _this.queryData();
                    });
                }).catch(() => {
                });
            },
            createRow() {
                _this.dialogName = '添加';
                _this.imageUrl = ""
                _this.cmdDialogVisible = true;
                _this.$nextTick(() => {
                    _this.cmd = {
                        content: "",
                        name:"",
                        url:"",
                        type:2,
                        fileName:"",
                      fileUrl:"",
                      fileName1:"",
                      isSelect: false,
                      modelType: "local"
                    };
                    _this.$refs.cmd.resetFields();
                });
            },
            modifyRow(item) {
                _this.dialogName = '编辑';
                _this.cmdDialogVisible = true;
                _this.$nextTick(() => {
                    _this.cmd = JSON.parse(JSON.stringify(item));
                    _this.$refs.cmd.resetFields();
                });
            },
            statusRow(item) {
              _this.$confirm('此操作将'+(item.status?'禁用':'启用')+', 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                let param = JSON.parse(JSON.stringify(item))
                param.status = !param.status
                request({
                  url: '/public/presets/modify',
                  method: 'post',
                  data: param
                }).then(res => {
                  _this.$message.success((item.status?'禁用':'启用')+"成功");
                  _this.queryData();
                });
              }).catch(() => {
              });
            },
            submitModify() {
                this.$refs.cmd.validate((valid) => {
                    if (valid) {
                        if (_this.cmd.id && _this.cmd.id.toString.length > 0) {
                            request({
                                url: '/public/presets/modify',
                                method: 'post',
                                data: _this.cmd
                            }).then(res => {
                                _this.$message.success("编辑成功");
                                _this.cmdDialogVisible = false;
                                _this.queryData();
                            });
                        } else {
                            request({
                                url: '/public/presets/create',
                                method: 'post',
                                data: _this.cmd
                            }).then(res => {
                                _this.$message.success("添加成功");
                                _this.cmdDialogVisible = false;
                                _this.queryData();
                            });
                        }
                    }
                });
            },
            handleFileChange(file){
              this.$refs.upload.clearFiles();

              // let FileExt = file.raw.name.replace(/.+\./, "");
              // let msg = "请上传json文件"
              // if (['json'].indexOf(FileExt.toLowerCase()) === -1){
              //   this.$message({ type: 'warning', message: msg });
              //   return false;
              // }
              _this.$set(_this.cmd, "fileName", file.raw.name)
              let formData = new FormData();
              formData.append("file", file.raw);
              request({
                url: '/upload/file/json',
                method: 'post',
                data: formData
              }).then(res => {
                _this.cmd.url = res;
              });
            },
            clearFile(name, url){
              this.$set(this.cmd, name, "")
              this.$set(this.cmd, url, "")
            },
            handleFileChange1(file){
              this.$refs.upload1.clearFiles();

              // let FileExt = file.raw.name.replace(/.+\./, "");
              // let msg = "请上传json文件"
              // if (['json'].indexOf(FileExt.toLowerCase()) === -1){
              //   this.$message({ type: 'warning', message: msg });
              //   return false;
              // }
              _this.$set(_this.cmd, "fileName1", file.raw.name)
              let formData = new FormData();
              formData.append("file", file.raw);
              request({
                url: '/upload/file/json',
                method: 'post',
                data: formData
              }).then(res => {
                _this.cmd.fileUrl = res;
              });
            },
        }
    }
</script>

<style  lang="scss">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
